<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="blog-area pt-0 mt-0">
            <div class="blog-title">
              <!-- User Interface controls -->
              <b-row class="pb-2 pt-3 text-right">
                <b-col class="mb-1 " cols="3" v-if="backButton">
                  <router-link to="/digitalleaders2023/meta-ranking" class="theme-btn"
                    >Back to main</router-link
                  >
                </b-col>
                <b-col class="p-0 mb-1 text-left" cols="3">
                  <a
                    v-if="Object.keys(modal).length > 0"
                    href="#"
                    v-b-modal="'modal-methodo'"
                    class="theme-btn"
                    >Methodology</a
                  >
                </b-col>
                <b-col class="mb-1 text-left" cols="6">
                  <b-form-group
                    label="Filter"
                    label-cols-sm="3"
                    label-align-sm="right"
                    label-size="sm"
                    label-for="filterInput"
                    class="mb-0"
                  >
                    <b-input-group size="sm">
                      <b-form-input
                        v-model="filter"
                        type="search"
                        id="filterInput"
                        placeholder="Type to Search"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-table
                    bordered
                    hover
                    :items="ranking"
                    small
                    :per-page="perPage"
                    :current-page="currentPage"
                    :fields="fields"
                    :filter="filter"
                    thead-class="ranking-head text-center"
                    stacked="sm"
                    responsive="sm"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    sort-icon-left
                  >
                  </b-table>
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    align="left"
                    size="sm"
                    class="my-0"
                    v-if="totalRows > perPage"
                  ></b-pagination
                  ><br />
                  <a :href="this.$route.meta.link" target="_new" v-if="this.$route.meta.link">{{
                    this.$route.meta.linkText
                  }}</a>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-methodo" :title="modal.title">
      <p class="my-4" v-html="modal.text"></p>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ranking: [],
      filter: '',
      perPage: 30,
      totalRows: 1,
      currentPage: 1,
      sortBy: '2020',
      sortDesc: false
    };
  },

  async created() {
    const response = await fetch(this.$route.meta.file);
    this.ranking = await response.json();
    this.totalRows = this.ranking.length;
  },
  props: {
    file: {
      type: String
    },
    modal: {
      type: Object
    },
    fields: {
      type: Array
    },
    backButton: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
